export var getDefaultStyleSheet = _ref => {
  var {
    designContext
  } = _ref;
  var textStyles = designContext.get('text-style/text/paragraphs/default/medium').styles();
  return {
    root: {
      fontFamily: textStyles.fontFamily,
      fontWeight: textStyles.fontWeight
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map